// Акцентните палитри на панелите в Конфигурация — отделен файл (не в
// ConfigPanel.tsx), защото react-refresh иска компонентните файлове да
// изнасят само компоненти.

export type PanelAccent = {
  main: string;
  deep: string;
  tint: string;
  tint2: string;
  tintBorder: string;
  // По-наситена рамка за „избрано" състояние (карти с опции).
  strongBorder: string;
  // Мек пръстен за фокус на инпут в цвета на секцията.
  focusRing: string;
};

// Неутрални панели, разликата между секциите е САМО в акцента: оранжево е
// основният цвят на приложението, синьото е „второто" (шпикери/фискални),
// зелено и виолетово са за таблиците с повече от две секции. Страницата
// „Маркиране" НЕ ги ползва — там всичко е в нюанси на кехлибареното.
export const PANEL_ACCENTS: Record<
  "amber" | "blue" | "green" | "violet",
  PanelAccent
> = {
  amber: {
    main: "#D97706",
    deep: "var(--color-brand-deep-ink)",
    tint: "var(--color-brand-tint)",
    tint2: "var(--color-brand-tint2)",
    tintBorder: "var(--color-brand-tint2)",
    strongBorder: "rgba(217, 119, 6, 0.42)",
    focusRing: "rgba(217, 119, 6, 0.12)",
  },
  blue: {
    main: "#2E7CAE",
    deep: "var(--color-info-deep)",
    tint: "var(--color-info-tint)",
    tint2: "var(--color-info-tint2)",
    tintBorder: "rgba(46, 124, 174, 0.25)",
    strongBorder: "rgba(46, 124, 174, 0.42)",
    focusRing: "rgba(46, 124, 174, 0.12)",
  },
  green: {
    main: "#3D8B5F",
    deep: "var(--color-ok-deep)",
    tint: "var(--color-ok-tint)",
    tint2: "var(--color-ok-tint2)",
    tintBorder: "rgba(61, 139, 95, 0.25)",
    strongBorder: "rgba(61, 139, 95, 0.42)",
    focusRing: "rgba(61, 139, 95, 0.12)",
  },
  violet: {
    main: "#6D5BB8",
    deep: "var(--color-violet)",
    tint: "var(--color-violet-tint)",
    tint2: "var(--color-violet-tint2)",
    tintBorder: "rgba(109, 91, 184, 0.25)",
    strongBorder: "rgba(109, 91, 184, 0.42)",
    focusRing: "rgba(109, 91, 184, 0.12)",
  },
};
